import React from 'react';
import { SectionConfig } from '../../types';
import { Section } from './Section';

interface SuperSectionProps {
  sections: SectionConfig[];
}

export function SuperSection({ sections }: SuperSectionProps) {
  return (
    <>
      {sections
        .filter((s) => s.render !== false)
        .map((section, index) => (
          <Section key={`${section.name}-${index}`} config={section} />
        ))}
    </>
  );
}
